import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    automobile: [
//         {
//             registrationNumber: '登録番号1',
//             type: '種別1',
//             use: '用途1',
//             privateBusiness: '自家用・事業用の別1',
//             name: '車名',
//             model: '型式1',
//             chassisNumber: '車台番号1',
//             primeMoverModel: '原動機の型式1',
//             targetPerson: 'テスト相続人1',
//             inheritanceBequest: '相続',
//         },
//         {
//             registrationNumber: '登録番号2',
//             type: '種別2',
//             use: '用途2',
//             privateBusiness: '自家用・事業用の別2',
//             name: '車名',
//             model: '型式2',
//             chassisNumber: '車台番号2',
//             primeMoverModel: '原動機の型式2',
//             targetPerson: 'テスト相続人2',
//             inheritanceBequest: '相続',
//         },
//         {
//             registrationNumber: '登録番号3',
//             type: '種別3',
//             use: '用途3',
//             privateBusiness: '自家用・事業用の別3',
//             name: '車名',
//             model: '型式3',
//             chassisNumber: '車台番号3',
//             primeMoverModel: '原動機の型式3',
//             targetPerson: 'テスト相続人3',
//             inheritanceBequest: '相続',
//         }
    ]
};

const slice = createSlice({
    name: 'automobile',
    initialState,
    reducers: {
        setAutomobile: (state, action) => {
            return Object.assign({}, state, { automobile: state.automobile.concat(action.payload) })
        },
        clearAutomobile: (state, action) => {
            const newArray = Array.from(new Set([...state.automobile]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { automobile: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setAutomobile,
    clearAutomobile,
} = slice.actions;
